<template>
  <!-- 品項備註(itemNote)、整單備註(memo) -->
  <cus-dialog v-if="name === 'itemNote' || name === 'memo'">
    <template v-slot:body>
      <div class="wrap">
        <cus-input
          v-model:value="input"
          type="text-area"
          :placeholder="name === 'itemNote' ? '請輸入商品備註，字數限12字以內' : '請輸入訂單備註，字數限200字以內'"
          :errorText="name === 'itemNote' ? errorText.item_note : errorText.memo"
          :rows="10"
          v-model:inputBlur="validateOnBlur"
        ></cus-input>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="儲存" color="blue" :width="50" @click="submitInput(input)"></cus-button>
      </div>
    </template>
  </cus-dialog>
  <!-- 訂購人資訊 -->
  <cus-dialog v-if="name === 'consumer'">
    <template v-slot:body>
      <div class="wrap">
        <!-- 姓名 -->
        <cus-input v-model:value="input.order_user_name" placeholder="姓名"></cus-input>
        <!-- 電話 -->
        <div data-action="edit" style="width: 100%" tabindex="-1" @click="handleOpenDialog($event, 'inputTel')">
          <div data-action="edit" :class="['order-user-tel', errorText.order_user_tel ? 'input-error-status' : '']">
            <p :class="input.order_user_tel ? 'input-color' : ''" data-action="edit">
              {{ input.order_user_tel || '電話' }}
            </p>
            <div v-if="!input.order_user_tel" class="action-icon">
              <i data-action="edit" class="bi bi-pencil"></i>
            </div>
            <div v-else class="action-icon">
              <i data-action="delete" class="bi bi-x-circle" @click="input.order_user_tel = ''"></i>
            </div>
          </div>
        </div>
        <!-- 外送平台 -->
        <cus-input
          v-if="cusProps.source === 'foodpanda' || cusProps.source === 'uber_eat'"
          v-model:value="input.outside_order_id"
          :placeholder="`${mapValue[cusProps.source]?.label}取餐號`"
          :errorText="errorText.outside_order_id"
        ></cus-input>
        <!-- 時間 -->
        <div data-action="edit" tabindex="-1" class="time-picker" @click="handleOpenDialog($event, 'timePicker')">
          <p :class="['time-picker-text', input.order_take_time ? 'input-color' : '']" data-action="edit">
            {{
              timeOutput(input.order_take_time ? input.order_take_time.split(' ')[1] : input.order_take_time) || '時間'
            }}
          </p>
          <div v-if="!input.order_take_time" class="action-icon"><i data-action="edit" class="bi bi-clock"></i></div>
          <div v-else class="action-icon">
            <i data-action="delete" class="bi bi-x-circle" @click="input.order_take_time = ''"></i>
          </div>
        </div>
        <!-- 地址 -->
        <cus-input
          v-model:value="input.order_user_address"
          placeholder="地址"
          :errorText="errorText.address"
          v-model:inputBlur="validateOnBlur"
        ></cus-input>
        <!-- 備註 -->
        <cus-input v-model:value="input.note" type="text-area" placeholder="訂購人備註"></cus-input>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="確定" color="blue" :width="50" @click="submitInput(input)"></cus-button>
      </div>
    </template>
  </cus-dialog>
  <!-- 手動輸入 -->
  <cus-dialog v-if="name === 'enterCode'">
    <template v-slot:body>
      <div class="wrap">
        <cus-input
          v-model:value="input"
          :placeholder="cusProps.scanType === 4 ? '手機條碼' : '自然人憑證 或 捐贈碼'"
          :errorText="errorText.carrier_no"
          v-model:inputBlur="validateOnBlur"
        ></cus-input>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="確定" color="blue" :width="50" @click="submitInput(input)" :disabled="!input"></cus-button>
      </div>
    </template>
  </cus-dialog>
  <!-- 執行作廢 -->
  <cus-dialog v-if="name === 'voidOrder'">
    <template v-slot:body>
      <div class="wrap">
        <cus-input v-model:value="input.account" placeholder="帳號" :errorText="errorText.account"></cus-input>
        <cus-input
          v-model:value="input.password"
          placeholder="密碼"
          :errorText="errorText.password"
          type="password"
        ></cus-input>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          text="驗證"
          color="blue"
          :width="50"
          @click="submitInput(input)"
          :disabled="!input.account || !input.password"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>

  <!-- 電話/外送平台取餐號/選擇時間彈窗 -->
  <component :is="inner_dialogTemplate"></component>
</template>
<script>
import { ref, inject, watch, reactive, defineAsyncComponent, getCurrentInstance } from 'vue';
import { timeOutput } from '@/utils/datetime';
import { useDialogInDialog } from '@/utils/dialog';
import { mapValue } from '@/utils/define';
export default {
  name: 'input-info',
  components: {
    TimePicker: defineAsyncComponent(() => import('@/components/dialog/TimePicker.vue')),
    StringNumberInput: defineAsyncComponent(() => import('@/components/dialog/StringNumberInput.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //接受provide值
    const dialogVisible = inject('dialogVisible', false);
    const name = inject('name');
    const close = inject('close');
    const submit = inject('submit');
    const { cusProps } = inject('cusProps');
    //設定參數
    const input = ref('');
    let errorText = reactive({
      address: '',
      item_note: '',
      outside_order_id: '',
      account: '',
      password: '',
      carrier_no: '',
      memo: '',
    });
    //設定初始值
    if (dialogVisible) {
      if (cusProps?.init) input.value = JSON.parse(JSON.stringify(cusProps.init));
      if (cusProps?.outsideError) errorText.outside_order_id = cusProps?.outsideError;
    }
    //恢復初始值
    watch(dialogVisible, () => {
      input.value = '';
    });
    //檢查文字輸入
    const checkText = (val) => {
      let isPass = true;
      switch (name.value) {
        case 'consumer':
          errorText.address = val.order_user_address.validateAdd();
          //訂單來源為熊貓或uber eat，要檢查取餐號
          if (cusProps.source === 'foodpanda' || cusProps.source === 'uber_eat') {
            errorText.outside_order_id = val.outside_order_id.validateTextLimit(true, 8);
          }
          if (errorText.outside_order_id || errorText.address) isPass = false;
          break;
        case 'itemNote':
          errorText.item_note = val.validateTextLimit(false, 12);
          if (errorText.item_note) isPass = false;
          break;
        case 'enterCode':
          if (cusProps.scanType === 4) {
            errorText.carrier_no = val.validateMobileCarrier();
            if (errorText.carrier_no) isPass = false;
          }
          break;
        case 'memo':
          errorText.memo = val.validateTextLimit(false, 200);
          if (errorText.memo) isPass = false;
          break;
      }
      return isPass;
    };
    const validateOnBlur = ref(false);
    watch(validateOnBlur, () => {
      if (validateOnBlur.value) {
        checkText(input.value);
        validateOnBlur.value = false;
      }
    });
    //電話彈窗、外送平台取餐號彈窗、time-picker彈窗
    const { inner_dialogTemplate, openInnerDialog, closeInnerDialog } = useDialogInDialog();
    const handleOpenDialog = (e, name, dialogTitle) => {
      if (e.target.getAttribute('data-action') === 'edit') openInnerDialog(name, {}, { dialogTitle });
    };
    const handleUserTel = (val) => {
      if (val.validateTel()) {
        proxy.$message('錯誤提示', val.validateTel()).catch((e) => e);
      } else {
        input.value.order_user_tel = val;
        closeInnerDialog();
      }
    };
    const handleTime = (val) => {
      if (val.validateTime()) {
        proxy.$message('時間錯誤', val.validateTime()).catch((e) => e);
      } else {
        const today = new Date().getLocalDateTime('date');
        input.value.order_take_time = today + ' ' + val;
        closeInnerDialog();
      }
    };
    const handleOutsideId = (val) => {
      input.value.outside_order_id = val;
      if (val) errorText.outside_order_id = '';
      closeInnerDialog();
    };
    //確認送出
    const submitInput = () => {
      let isPass = checkText(input.value);
      if (!isPass) return;
      let submitData = null;
      if (name.value === 'enterCode') {
        submitData = {
          type: cusProps.scanType,
          code: input.value.toUpperCase(),
        };
      } else {
        submitData = input.value;
      }
      submit(submitData);
    };
    return {
      timeOutput,
      mapValue,
      name,
      close,
      submit,
      cusProps,
      input,
      errorText,
      validateOnBlur,
      inner_dialogTemplate,
      handleOpenDialog,
      handleUserTel,
      handleTime,
      handleOutsideId,
      submitInput,
    };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  flex-direction: column;
  @include flex-between-end;
  padding: 0 4px;
}

.time-picker,
.order-user-tel,
.outside-order-id {
  @include input-basic;
  position: relative;
  height: $input-height;
  color: $color-gray-60;
  cursor: pointer;
  .input-color {
    color: $color-text;
  }
}
</style>
